import { RealtimeAdvancedSettingsCard } from "@/components/shared/forms/RealtimeAdvancedSettingsFields"
import { SipAdvancedFields } from "@/components/shared/forms/SipAdvancedFields"
import { AudioCodec } from "@/types/api/SimulatorType"

import type { createAgentPreviewMetadataView } from "./agent-preview-metadata-view"

interface SipAdvancedSettingsCardProps {
  voice: ReturnType<typeof createAgentPreviewMetadataView>["voice"]
  hasMultiPhoneSupport: boolean
  onMetadataUpdate: (update: Record<string, unknown>) => void
}

export function SipAdvancedSettingsCard({
  voice,
  hasMultiPhoneSupport,
  onMetadataUpdate,
}: SipAdvancedSettingsCardProps) {
  return (
    <RealtimeAdvancedSettingsCard>
      <SipAdvancedFields
        widebandEnabled={voice.audioCodec === AudioCodec.L16}
        onWidebandChange={
          hasMultiPhoneSupport
            ? (enabled) =>
                onMetadataUpdate({
                  audio_codec: enabled ? AudioCodec.L16 : AudioCodec.PCMU,
                })
            : undefined
        }
        customSipHeaders={voice.customSipHeaders}
        onCustomSipHeadersChange={(value) =>
          onMetadataUpdate({ custom_sip_headers: value })
        }
        mediaEncryption={voice.mediaEncryption}
        onMediaEncryptionChange={(value) =>
          onMetadataUpdate({ media_encryption: value })
        }
      />
    </RealtimeAdvancedSettingsCard>
  )
}
